import * as types from './types'
import globals from '@/plugins/globals.js'
export default {
  [types.RESET_LOOKUPS](state) {
    state.lookups = {}
  },
  [types.CHANGE_SORT](state, data) {
    let len = 0
    let idx = 0
    var current = null
    var previous = null
    var next = null
    let change = 0
    switch (data.key) {
      case 'CalibrateActionType':
        len = state.calibrateActionType.length
        idx = state.calibrateActionType.map(e => e.calibrateActionType).indexOf(data.id)
        current = state.calibrateActionType[idx]
        previous = state.calibrateActionType[(idx + len - 1) % len]
        next = state.calibrateActionType[(idx + 1) % len]
        change = 0
        if (data.direction === 'up') {
          change = previous.sort
          previous.sort = current.sort
          current.sort = change
          if (current.sort === previous.sort) {
            current.sort++
          }
        } else {
          change = next.sort
          next.sort = current.sort
          current.sort = change
          if (current.sort === next.sort) {
            next.sort++
          }
        }
        state.calibrateActionType = globals.sortArray(state.calibrateActionType, 'sort')
        break
      case 'CalibrateReady':
        len = state.calibrateReady.length
        idx = state.calibrateReady.map(e => e.calibrateReady).indexOf(data.id)
        current = state.calibrateReady[idx]
        previous = state.calibrateReady[(idx + len - 1) % len]
        next = state.calibrateReady[(idx + 1) % len]
        change = 0
        if (data.direction === 'up') {
          change = previous.sort
          previous.sort = current.sort
          current.sort = change
          if (current.sort === previous.sort) {
            current.sort++
          }
        } else {
          change = next.sort
          next.sort = current.sort
          current.sort = change
          if (current.sort === next.sort) {
            next.sort++
          }
        }
        state.calibrateReady = globals.sortArray(state.calibrateReady, 'sort')
        break
      case 'CalibratePreCheck':
        len = state.calibratePreCheckList.length
        idx = state.calibratePreCheckList.map(e => e.calibratePreCheck).indexOf(data.id)
        current = state.calibratePreCheckList[idx]
        previous = state.calibratePreCheckList[(idx + len - 1) % len]
        next = state.calibratePreCheckList[(idx + 1) % len]
        change = 0
        if (data.direction === 'up') {
          change = previous.sort
          previous.sort = current.sort
          current.sort = change
          if (current.sort === previous.sort) {
            current.sort++
          }
        } else {
          change = next.sort
          next.sort = current.sort
          current.sort = change
          if (current.sort === next.sort) {
            next.sort++
          }
        }
        state.calibratePreCheckList = globals.sortArray(state.calibratePreCheckList, 'sort')
        break
      case 'CalibrateService':
        len = state.calibrateService.length
        idx = state.calibrateService.map(e => e.calibrateService).indexOf(data.id)
        current = state.calibrateService[idx]
        previous = state.calibrateService[(idx + len - 1) % len]
        next = state.calibrateService[(idx + 1) % len]
        change = 0
        if (data.direction === 'up') {
          change = previous.sort
          previous.sort = current.sort
          current.sort = change
          if (current.sort === previous.sort) {
            current.sort++
          }
        } else {
          change = next.sort
          next.sort = current.sort
          current.sort = change
          if (current.sort === next.sort) {
            next.sort++
          }
        }
        state.calibrateService = globals.sortArray(state.calibrateService, 'sort')
        break
      case 'CalibrateVerify':
        len = state.calibrateVerify.length
        idx = state.calibrateVerify.map(e => e.calibrateVerify).indexOf(data.id)
        current = state.calibrateVerify[idx]
        previous = state.calibrateVerify[(idx + len - 1) % len]
        next = state.calibrateVerify[(idx + 1) % len]
        change = 0
        if (data.direction === 'up') {
          change = previous.sort
          previous.sort = current.sort
          current.sort = change
          if (current.sort === previous.sort) {
            current.sort++
          }
        } else {
          change = next.sort
          next.sort = current.sort
          current.sort = change
          if (current.sort === next.sort) {
            next.sort++
          }
        }
        state.calibrateVerify = globals.sortArray(state.calibrateVerify, 'sort')
        break
      default:
        len = state.lookups[data.key].length
        idx = state.lookups[data.key].map(e => e.id).indexOf(data.id)
        current = state.lookups[data.key][idx]
        previous = state.lookups[data.key][(idx + len - 1) % len]
        next = state.lookups[data.key][(idx + 1) % len]
        change = 0
        if (data.direction === 'up') {
          change = previous.sort
          previous.sort = current.sort
          current.sort = change
          if (current.sort === previous.sort) {
            current.sort++
          }
        } else {
          change = next.sort
          next.sort = current.sort
          current.sort = change
          if (current.sort === next.sort) {
            next.sort++
          }
        }
        state.lookups[data.key] = globals.sortArray(state.lookups[data.key], 'sort')
    }
  },
  [types.SET_LOOKUPS](state, [keys, lookups, showIsactive]) {
    let _lookups = {}
    for (let key of keys) {
      _lookups[key] = []
      if (lookups !== undefined && lookups !== null) {
        for (let lookup of lookups) {
          if (lookup.key === key) {
            lookup.name = lookup.value || lookup.name
            lookup.value = lookup.id
            lookup.isInactive = lookup.isInactive !== undefined ? lookup.isInactive : showIsactive
            _lookups[key].push(lookup)
          }
        }
      }
    }
    state.lookups = JSON.parse(JSON.stringify(Object.assign(state.lookups, _lookups)))
  },
  [types.UPSERT_LOOKUP](state, [lookup, id]) {
    lookup.id = id
    let section = state.groups.filter(group => group.sectionName === lookup.section)
    if (section.length > 0) {
      let index = section[0].children.findIndex(i => i.id === lookup.id)
      if (index >= 0) {
        section[0].children[index] = lookup
      } else {
        section[0].children.push(lookup)
      }
    }
  },
  [types.DELETE_LOOKUP](state, lookup) {
    try {
      let section = state.groups.filter(group => group.sectionName === lookup.section)
      if (section.length > 0) {
        let index = section[0].children.findIndex(i => i.id === lookup.id)
        section[0].children.splice(index, 1)
      }
    } catch (e) {}
  },
  [types.SET_GROUPS](state, groups) {
    state.groups = groups
  },
  [types.UPSERT_GROUP](state, data) {
    let group = state.groups.filter(g => g.id === data.id)
    if (group.length > 0) {
      group[0].sectionName = data.text
    }
  },
  [types.SET_COUNTRIES](state, data) {
    state.countries = data
    let _items = []
    for (let item of data) {
      item.value = parseInt(item.id)
      _items.push(item)
    }
    state.countries = JSON.parse(JSON.stringify(Object.assign(state.countries, _items)))
  },
  [types.SET_TIMEZONES](state, data) {
    state.timeZones = []
    let _items = []
    for (let item of data) {
      item.value = parseInt(item.id)
      _items.push(item)
    }
    state.timeZones = JSON.parse(JSON.stringify(Object.assign(state.timeZones, _items)))
  },
  [types.SET_STATE_PROVINCES](state, data) {
    state.stateProvinces = []
    let _items = []
    for (let item of data) {
      item.value = parseInt(item.id)
      _items.push(item)
    }
    state.stateProvinces = JSON.parse(JSON.stringify(Object.assign(state.stateProvinces, _items)))
    if (state.lookups['StateProvince'] !== undefined && state.lookups['StateProvince'] !== null) {
      state.lookups['StateProvince'] = state.stateProvinces
    }
  },
  [types.SET_LANGUAGES](state, data) {
    state.languages = []
    let _items = []
    for (let item of data) {
      item.value = parseInt(item.id)
      _items.push(item)
    }
    state.languages = JSON.parse(JSON.stringify(Object.assign(state.languages, _items)))
  },
  [types.SET_CALIBRATE_LISTS](state, data) {
    state.calibrateActionType = []
    state.calibrateReady = []
    state.calibratePreCheckList = []
    state.calibrateService = []
    state.calibrateVerify = []
    if (data !== undefined && data !== null) {
      data.forEach(element => {
        switch (element.key) {
          case 'CalibrateActionType':
            // console.log('load up action type', element)
            state.calibrateActionType.push({
              calibrateActionType: element.id,
              calibrateActionTypeName: element.value,
              isInactive: false,
              sort: element.sort !== undefined && element.sort !== null ? element.sort : 0,
              vehicleMake: element.vehicleMake,
              vehicleMakeName: element.vehicleMakeName,
              isOptional: false,
              isVideo: element.isVideo,
              isImage: element.isImage,
              isFile: element.isFile,
              isTestDrive: element.isTestDrive,
              calibrateServiceGroup: element.calibrateServiceGroup,
              calibrateServiceGroupName: element.calibrateServiceGroupName,
              calibrateEventType: element.calibrateEventType,
              calibrateEventTypeName: element.calibrateEventTypeName
            })
            break
          case 'CalibrateReady':
            state.calibrateReady.push({
              calibrateReady: element.id,
              calibrateReadyName: element.value,
              isInactive: false,
              sort: element.sort !== undefined && element.sort !== null ? element.sort : 0,
              vehicleMake: element.vehicleMake,
              vehicleMakeName: element.vehicleMakeName,
              calibrateServiceGroup: null,
              calibrateServiceGroupName: null,
              calibrateEventType: element.calibrateEventType,
              calibrateEventTypeName: element.calibrateEventTypeName
            })
            break
          case 'CalibratePreCheck':
            state.calibratePreCheckList.push({
              calibratePreCheck: element.id,
              calibratePreCheckName: element.value,
              isInactive: false,
              sort: element.sort !== undefined && element.sort !== null ? element.sort : 0,
              vehicleMake: element.vehicleMake,
              vehicleMakeName: element.vehicleMakeName,
              isOptional: false,
              isVideo: element.isVideo,
              isImage: element.isImage,
              isFile: element.isFile,
              calibrateServiceGroup: element.calibrateServiceGroup,
              calibrateServiceGroupName: element.calibrateServiceGroupName,
              calibrateEventType: element.calibrateEventType,
              calibrateEventTypeName: element.calibrateEventTypeName
            })
            break
          case 'CalibrateService':
            state.calibrateService.push({
              calibrateService: element.id,
              calibrateServiceName: element.value,
              isInactive: false,
              sort: element.sort !== undefined && element.sort !== null ? element.sort : 0,
              vehicleMake: element.vehicleMake,
              vehicleMakeName: element.vehicleMakeName,
              rate: element.rate,
              calibrateServiceGroup: element.calibrateService,
              calibrateServiceGroupName: element.calibrateServiceGroupName,
              calibrateEventType: element.calibrateEventType,
              calibrateEventTypeName: element.calibrateEventTypeName
            })
            break
          case 'CalibrateVerify':
            state.calibrateVerify.push({
              calibrateVerify: element.id,
              calibrateVerifyName: element.value,
              isInactive: false,
              sort: element.sort !== undefined && element.sort !== null ? element.sort : 0,
              vehicleMake: element.vehicleMake,
              vehicleMakeName: element.vehicleMakeName,
              calibrateVerifyTemplate: element.calibrateVerifyTemplate,
              calibrateServiceGroup: null,
              calibrateServiceGroupName: null,
              calibrateEventType: element.calibrateEventType,
              calibrateEventTypeName: element.calibrateEventTypeName
            })
            break
        }
      })
    }
  },
  [types.SET_CALIBRATE_READY](state, data) {
    state.calibrateReady = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.calibrateReady = data
      }
    }
  },
  [types.SET_CALIBRATE_PRECHECKLIST](state, data) {
    state.calibratePreCheckList = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.calibratePreCheckList = data
      }
    }
  },
  [types.SET_CALIBRATE_SERVICE](state, data) {
    state.calibrateService = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.calibrateService = data
      }
    }
  },
  [types.SET_CALIBRATE_ACTIONTYPE](state, data) {
    state.calibrateActionType = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.calibrateActionType = data
        console.log('Action Types 0', state.calibrateActionType)
      }
    }
  },
  [types.SET_CALIBRATE_VERIFY](state, data) {
    state.calibrateVerify = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.calibrateVerify = data
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/mutations.js